import { createContext, useContext, useMemo, useState } from 'react';

export const defaultWeightValues = {
	community: 50,
	setCommunity: () => {},
	household: 50,
	setHousehold: () => {},
	society: 50,
	setSociety: () => {},
	individual: 50,
	setIndividual: () => {},
	isEmpty: true,
};

const WeightContext = createContext(defaultWeightValues);

export const WeightProvider = ({ children }) => {
	const [community, setCommunity] = useState(defaultWeightValues.community);
	const [household, setHousehold] = useState(defaultWeightValues.household);
	const [society, setSociety] = useState(defaultWeightValues.society);
	const [individual, setIndividual] = useState(defaultWeightValues.individual);

	const isEmpty = useMemo(() => {
		let isDefault = true;

		for (const value of [community, household, society, individual]) {
			if (value !== defaultWeightValues.community) {
				isDefault = false;
				break;
			}
		}

		return isDefault;
	}, [community, household, society, individual]);

	const value = useMemo(
		() => ({ community, setCommunity, household, setHousehold, society, setSociety, individual, setIndividual, isEmpty }),
		// Stable identity: the chart's draw effect depends on this object, and a new
		// one every render would rebind and re-transition every shape.
		[community, setCommunity, household, setHousehold, society, setSociety, individual, setIndividual, isEmpty]
	);

	return <WeightContext.Provider value={value}>{children}</WeightContext.Provider>;
};

export const useWeightContext = () => useContext(WeightContext);
